var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "incubator-consent" }, [
    _c("div", { staticClass: "apply-form-block" }, [
      _c("div", { staticClass: "consent-container" }, [
        _c("h2", { staticClass: "consent-title" }, [
          _vm._v(" " + _vm._s(_vm.$t("IncubatorApply.Consent.title")) + " "),
        ]),
        _c("p", { staticClass: "consent-intro" }, [
          _vm._v(" " + _vm._s(_vm.$t("IncubatorApply.Consent.intro")) + " "),
        ]),
        _c("p", { staticClass: "consent-intro" }, [
          _vm._v(
            " " + _vm._s(_vm.$t("IncubatorApply.Consent.pleaseRead")) + " "
          ),
        ]),
        _c(
          "div",
          { staticClass: "consent-scroll-area" },
          [
            _vm.isZh
              ? [
                  _c("p", { staticClass: "lead" }, [
                    _vm._v(
                      " 財團法人中華民國佛教慈濟慈善事業基金會（下稱本會）依據個人資料保護法、本會之個人資料保護政策及辦法，在向您蒐集個人資料前，依法向您告知下列事項，敬請詳閱： "
                    ),
                  ]),
                  _vm._m(0),
                  _vm._m(1),
                  _vm._m(2),
                  _vm._m(3),
                  _vm._m(4),
                  _vm._m(5),
                  _vm._m(6),
                  _vm._m(7),
                ]
              : [
                  _c("p", { staticClass: "lead" }, [
                    _vm._v(
                      ' Buddhist Tzu Chi Charity Foundation (hereinafter referred to as the "Foundation"), in accordance with the Personal Data Protection Act and Personal Data Protection Policies and regulations of the Foundation, hereby informs you of the following matters prior to the collection of your personal data. Please kindly review: '
                    ),
                  ]),
                  _vm._m(8),
                  _vm._m(9),
                  _vm._m(10),
                  _vm._m(11),
                  _vm._m(12),
                  _vm._m(13),
                  _vm._m(14),
                  _vm._m(15),
                ],
          ],
          2
        ),
        _c("p", { staticClass: "consent-note" }, [
          _vm._v(" " + _vm._s(_vm.$t("IncubatorApply.Consent.note")) + " "),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "consent-checkbox" },
        [
          _c("v-checkbox", {
            attrs: {
              label: _vm.$t("IncubatorApply.Consent.checkbox"),
              color: "#F97E2B",
            },
            model: {
              value: _vm.agreed,
              callback: function ($$v) {
                _vm.agreed = $$v
              },
              expression: "agreed",
            },
          }),
        ],
        1
      ),
      _c("div", { staticClass: "consent-actions" }, [
        _c(
          "div",
          {
            staticClass: "btn orange-btn",
            class: { disabled: !_vm.agreed },
            on: { click: _vm.nextStep },
          },
          [_vm._v(" " + _vm._s(_vm.$t("IncubatorApply.Consent.button")) + " ")]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "numbered-item" }, [
      _c("span", { staticClass: "num" }, [_vm._v("一、")]),
      _c("div", { staticClass: "content" }, [
        _vm._v(
          " 本會基於章程業務、活動、社會服務、行政管理及宣傳推廣活動等目的，蒐集、處理及利用個人資料。 "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "numbered-item" }, [
      _c("span", { staticClass: "num" }, [_vm._v("二、")]),
      _c("div", { staticClass: "content" }, [
        _vm._v(
          " 本會蒐集之個人資料類別如填寫頁所示，請您填寫正確且最新及完整的個人資料，若有任何異動，請即時向本會更正。 "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "numbered-item" }, [
      _c("span", { staticClass: "num" }, [_vm._v("三、")]),
      _c("div", { staticClass: "content" }, [
        _vm._v(
          " 本會蒐集、處理、利用、傳輸您個人資料之期間、地區、對象及方式如下： "
        ),
        _c("div", { staticClass: "sub-item" }, [
          _c("span", { staticClass: "num" }, [_vm._v("（一）")]),
          _c("div", { staticClass: "content" }, [
            _vm._v(
              "期間：本會僅於特定目的存續期間利用您個人資料，但因執行職務或業務所必須或經您同意者，不在此限。"
            ),
          ]),
        ]),
        _c("div", { staticClass: "sub-item" }, [
          _c("span", { staticClass: "num" }, [_vm._v("（二）")]),
          _c("div", { staticClass: "content" }, [
            _vm._v("地區：本會執行職務或業務之國內外地區。"),
          ]),
        ]),
        _c("div", { staticClass: "sub-item" }, [
          _c("span", { staticClass: "num" }, [_vm._v("（三）")]),
          _c("div", { staticClass: "content" }, [
            _vm._v(
              "對象：您個人資料將使用在本會、其他本會志業體、受本會委託處理相關事務之第三人、因履行契約所必要之第三人、其他業務相關之第三人、政府機構、其他未受中央目的事業主管機關限制國際傳輸之接收者。"
            ),
          ]),
        ]),
        _c("div", { staticClass: "sub-item" }, [
          _c("span", { staticClass: "num" }, [_vm._v("（四）")]),
          _c("div", { staticClass: "content" }, [
            _vm._v(
              "方式：您個人資料將以自動化機器或其他非自動化之利用方式，並以合理方式使用。利用方式包括但不限於以言詞、書面、電話、簡訊、電子郵件、傳真、電子文件或其他合於當時科學技術之適當方式。"
            ),
          ]),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "numbered-item" }, [
      _c("span", { staticClass: "num" }, [_vm._v("四、")]),
      _c("div", { staticClass: "content" }, [
        _vm._v(
          " 您得到本會官網聯絡窗口，就您個人資料向本會行使以下權利：（一）查詢或請求閱覽。（二）請求製給複製本。（三）請求補充或更正。（四）請求停止蒐集、處理及利用。（五）請求刪除。"
        ),
        _c("br"),
        _vm._v(
          " 本會得依個人資料保護法及相關法律規定、執行職務及業務所必須或經您書面同意時，拒絕您行使上述權利。"
        ),
        _c("br"),
        _vm._v(
          " 若您因行使上述權利，而致權益受損時，本會將不負相關賠償責任。 "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "numbered-item" }, [
      _c("span", { staticClass: "num" }, [_vm._v("五、")]),
      _c("div", { staticClass: "content" }, [
        _vm._v(
          " 您得自由選擇提供個人資料，如選擇您不提供個人資料，本會可能無法提供蒐集目的之相關服務。 "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "numbered-item" }, [
      _c("span", { staticClass: "num" }, [_vm._v("六、")]),
      _c("div", { staticClass: "content" }, [
        _vm._v(
          " 若因本同意書涉訟，您同意以中華民國法律為準據法，並以臺灣花蓮地方法院為第一審管轄法院。 "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "numbered-item" }, [
      _c("span", { staticClass: "num" }, [_vm._v("七、")]),
      _c("div", { staticClass: "content" }, [
        _vm._v(" 您同意本會留存此同意書，供日後取出查驗。 "),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "consent-notice" }, [
      _c("p", { staticClass: "notice-highlight" }, [
        _vm._v(
          " ※您於相關文件填寫個人資料，即視為同意個人資料提供予本會，代表： "
        ),
      ]),
      _c("p", [
        _vm._v(
          "您已閱讀、瞭解並同意接受本同意書之規定，並同意本會於所列蒐集目的之必要範圍內，蒐集、處理及利用本人之個人資料。"
        ),
      ]),
      _c("p", [
        _vm._v(
          "若您未滿十八歲，您確認已經法定代理人閱讀、瞭解並同意本同意書之所有內容，並遵守本同意書所有規範，始得填寫。"
        ),
      ]),
      _c("p", [
        _vm._v(
          "若您是代填報者，您保證已向個人資料所有人說明本同意書之內容，並獲得個人資料所有人之同意，始填報相關個人資料。"
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "numbered-item" }, [
      _c("span", { staticClass: "num" }, [_vm._v("1.")]),
      _c("div", { staticClass: "content" }, [
        _vm._v(
          " The Foundation collects, processes, and uses personal data for the purpose of, including but not limited to, the business stipulated in the Articles of Incorporation, events, social services, administrative works, promotional and outreach activities. "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "numbered-item" }, [
      _c("span", { staticClass: "num" }, [_vm._v("2.")]),
      _c("div", { staticClass: "content" }, [
        _vm._v(
          " The categories of personal data to be collected by the Foundation are as specified in the filling form. Please provide correct, updated, and complete personal data. In the event of any changes to the aforementioned data, please promptly notify the Foundation to make necessary corrections. "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "numbered-item" }, [
      _c("span", { staticClass: "num" }, [_vm._v("3.")]),
      _c("div", { staticClass: "content" }, [
        _vm._v(
          " The time period, region, recipients, and methods of your personal data which the Foundation collects, processes, uses, and transmits are as follows: "
        ),
        _c("div", { staticClass: "sub-item" }, [
          _c("span", { staticClass: "num" }, [_vm._v("I.")]),
          _c("div", { staticClass: "content" }, [
            _vm._v(
              "Time period: The Foundation shall only use your personal data for as long as the aforementioned specific purposes remain valid, except where such use is either necessary for the performance of an official or business duty, or has been otherwise agreed to by you."
            ),
          ]),
        ]),
        _c("div", { staticClass: "sub-item" }, [
          _c("span", { staticClass: "num" }, [_vm._v("II.")]),
          _c("div", { staticClass: "content" }, [
            _vm._v(
              "Region: Within both domestic and foreign areas that are related to the performance of an official or business duty of the Foundation."
            ),
          ]),
        ]),
        _c("div", { staticClass: "sub-item" }, [
          _c("span", { staticClass: "num" }, [_vm._v("III.")]),
          _c("div", { staticClass: "content" }, [
            _vm._v(
              "Recipients: Your personal data will be used by the Foundation, other affiliated entities of the Foundation, any third party commissioned by the Foundation to deal with relevant matters, any third party necessary for the performance of contracts, any other business-related third party, government agencies, and other recipients not subject to international transmit restrictions imposed by the central competent authorities."
            ),
          ]),
        ]),
        _c("div", { staticClass: "sub-item" }, [
          _c("span", { staticClass: "num" }, [_vm._v("IV.")]),
          _c("div", { staticClass: "content" }, [
            _vm._v(
              "Methods: Your personal data will be utilized by automated or non-automated means, and in a reasonable manner. The methods of use include but are not limited to, verbal and written communications, telephone calls, text messages, emails, facsimiles, electronic documents, or any other proper means consistent with the technology available at the time."
            ),
          ]),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "numbered-item" }, [
      _c("span", { staticClass: "num" }, [_vm._v("4.")]),
      _c("div", { staticClass: "content" }, [
        _vm._v(
          " You may exercise the following rights with regard to your personal data by contacting the designated contact listed on the Foundation's official website: (1) the right to make an inquiry of and to review your personal data; (2) the right to request a copy of your personal data; (3) the right to supplement or correct your personal data; (4) the right to demand the cessation of the collection, processing or use of your personal data; and (5) the right to erase your personal data."
        ),
        _c("br"),
        _vm._v(
          " The Foundation may, in accordance with the Personal Data Protection Act and other applicable laws and regulations or necessary for the performance of an official or business duty, or have been consented to by you in writing, reject your request to exercise the abovementioned rights."
        ),
        _c("br"),
        _vm._v(
          " If you suffer any loss of rights or benefits from exercising the abovementioned rights, the Foundation will not be liable for any related compensation. "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "numbered-item" }, [
      _c("span", { staticClass: "num" }, [_vm._v("5.")]),
      _c("div", { staticClass: "content" }, [
        _vm._v(
          " You are free to decide whether to provide your personal data. However, if you choose not to provide your personal data, the Foundation may be unable to provide services relevant to the purposes for which the data is collected. "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "numbered-item" }, [
      _c("span", { staticClass: "num" }, [_vm._v("6.")]),
      _c("div", { staticClass: "content" }, [
        _vm._v(
          " In the event that any litigious proceedings arise relating to the Consent Form, you agree that such proceedings shall be governed and interpreted by the laws of the Republic of China, and the Taiwan Hualien District Court shall be the court of first instance. "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "numbered-item" }, [
      _c("span", { staticClass: "num" }, [_vm._v("7.")]),
      _c("div", { staticClass: "content" }, [
        _vm._v(
          " You agree that the Foundation may keep the Consent Form for the purpose of future reference and verification. "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "consent-notice" }, [
      _c("p", { staticClass: "notice-highlight" }, [
        _vm._v(
          " ※By providing your personal information in the relevant documents, you are deemed to have consented to providing your personal data to the Foundation as follows: "
        ),
      ]),
      _c("p", [
        _vm._v(
          "You have read, understood, and agreed to the terms of the Consent Form, and agree to the Foundation's collection, processing, and use of your personal data within the necessary scope of specific purposes as set forth herein."
        ),
      ]),
      _c("p", [
        _vm._v(
          "If you are under the age of 18, you confirm that your guardian has read, understood, and agreed to all the contents of the Consent Form, and shall comply with all provisions herein before providing any personal data."
        ),
      ]),
      _c("p", [
        _vm._v(
          "If you are filling in the form on behalf of another individual, you warrant that you have fully explained the contents of this Consent Form to the data subject and have obtained his/her consent before providing any personal data."
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }